import React from "react";

import {Row, Col, Card} from "react-bootstrap";
import {Link} from "react-router-dom";

import story_data from '../data/stories';


const Story = () => {

    let thumbs = story_data.map((item, idx )=> {

            
            return (
                <Col key={`item-` + idx}>
                    <Link to={`/story/` + item.id}>
                        <Card className="text-center">
                            <Card.Img variant="top" src={item.thumbnail} />
                            <Card.Body >
                                <Card.Title>{item.short_title}</Card.Title>
                            </Card.Body>
                        </Card>
                    </Link>

                </Col>
            );
        
    });

    return (
        <Col className="mt-5 pt-5">

            <h1 className="text-center">Student Stories</h1>
            
            <p>What advice would you give yourself starting out in university?</p>

            <Row xs={2} className="g-4">
                { thumbs }
            </Row>
        </Col>
    )
}

export default Story;